import { render, staticRenderFns } from "./cPopupTip.vue?vue&type=template&id=d61f6172&scoped=true"
import script from "./cPopupTip.vue?vue&type=script&lang=js"
export * from "./cPopupTip.vue?vue&type=script&lang=js"
import style0 from "./cPopupTip.vue?vue&type=style&index=0&id=d61f6172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61f6172",
  null
  
)

export default component.exports